import { gql, useMutation } from '@apollo/client';

import { GET_DOCUMENTS_BY_IDS } from 'src/hooks/documents/get-documents-by-ids.hook';

import { GET_EMPLOYEE_DOCUMENTS } from './get-employee-documents.hook';

export const DELETE_EMPLOYEE_DOCUMENT_TEMPLATE = gql`
  mutation deleteMemberDocumentTemplate($payload: DeleteMemberDocumentTemplateInput!) {
    deleteMemberDocumentTemplate(payload: $payload) {
      _id
    }
  }
`;

export const useDeleteEmployeeDocumentTemplate = ({ onSuccess }: { onSuccess?: () => void }) => {
  const [deleteEmployeeDocumentTemplate] = useMutation(DELETE_EMPLOYEE_DOCUMENT_TEMPLATE, {
    refetchQueries: [GET_EMPLOYEE_DOCUMENTS, GET_DOCUMENTS_BY_IDS],
    onCompleted: onSuccess,
  });

  return deleteEmployeeDocumentTemplate;
};
